import { Button, Grid } from '@mui/material';
import React, { useEffect } from 'react';
import './DatabaseBackup.scss';
import { useDispatch, useSelector } from 'react-redux';
import { quickInputSelector } from '../QuickInput/reducers/QuickInputReducer';
import BackupFileModel from './models/BackupFileModel';
import DatatableColumnModel from '../Datatable/DatatableColumnModel';
import { databaseBackupSelector, setDatabaseBackupFiles, setOrderBy, setOrderDirection } from './reducers/DatabaseBackupReducer';
import moment from 'moment';
import DatabaseBackupApi, { RestoreDatabaseParam } from './api/DatabaseBackupApi';
import BaseResponse from '../../app/BaseResponse';
import { showLoading } from '../LoadingView/reducers/LoadingViewReducer';
import Utility from '../../app/utility';
import Datatable, { PagingTypeEnum } from '../Datatable/Datatable';
import { OrderDirection } from '../Datatable/OrderDirection';
import _ from 'lodash';
import Swal from 'sweetalert2';
import Api from '../../app/apiRequest';

const DatabaseBackup: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const quickInputData = useSelector(quickInputSelector);

    let databaseBackupData = useSelector(databaseBackupSelector);

    const getAll = () => {
        dispatch(showLoading(true));

        DatabaseBackupApi.GetBackupFiles()
            .then((response: BaseResponse<BackupFileModel[]>) => {
                if (response.success) {
                    dispatch(setDatabaseBackupFiles(response.data));
                } else {
                    Utility.Alert.Error(response.message);
                }
            }).catch((error) => {
                Utility.Alert.Error(error);
            })
            .finally(() => {
                dispatch(showLoading(false));
            });
    }

    useEffect(() => {
        getAll()
    }, []);

    const columns = [
        {
            Field: "CreatedDate",
            Title: "Backup File Created Date",
            AllowSort: true,
            Render: (rowData: BackupFileModel) => (
                <>
                    {formatUpdatedDate(rowData.createdDate)}
                </>
            )
        } as DatatableColumnModel<BackupFileModel>,
        {
            Field: "",
            Title: "",
            AllowSort: true,
            Render: (rowData: BackupFileModel) => (
                <>
                    <Button
                        variant='outlined'
                        onClick={() => {
                            Swal.fire({
                                title: 'Do you really want to restore database, this action can not be un-done. Do you want to do it anyway?',
                                icon: 'warning',
                                showCancelButton: true,
                                confirmButtonColor: '#3085d6',
                                cancelButtonColor: '#d33',
                                confirmButtonText: 'Yes',
                                cancelButtonText: 'No'
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    DatabaseBackupApi.Restore({
                                        fileName: rowData.fileName
                                    } as RestoreDatabaseParam)
                                        .then((response: BaseResponse<string>) => {
                                            if (response.success) {
                                                Utility.Alert.Success("Restore database successful");
                                                dispatch(showLoading(false));
                                            } else {
                                                Utility.Alert.Error(response.message);
                                                dispatch(showLoading(false));
                                            }
                                        }).catch((error) => {
                                            Utility.Alert.Error(error);
                                            dispatch(showLoading(false));
                                        })
                                }
                            })
                        }}
                    >RESTORE</Button>
                </>
            )
        } as DatatableColumnModel<BackupFileModel>,
    ];

    const formatUpdatedDate = (dateString: string): string => {
        let date = new Date(dateString);
        return moment(date).format("DD/MM/YYYY HH:mm");
    };

    return (
        <>
            <div className='datatable-wrapper'>
                <Grid
                    container
                    justifyContent="flex-end"
                    className="table-search-result-utility-bar"
                >
                    <Grid>
                        <Button
                            color="secondary"
                            variant='outlined'
                            className='table-search-result-utility-bar-item'
                            onClick={() => {
                                let url = Api.constructGetUrl("/api/Tonnage/Export", {});

                                const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
                                if (newWindow) newWindow.opener = null
                            }}
                        >Export Tonnages</Button>
                        <Button
                            color="secondary"
                            variant='outlined'
                            className='table-search-result-utility-bar-item'
                            onClick={() => {
                                let url = Api.constructGetUrl("/api/Cargo/Export", {});

                                const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
                                if (newWindow) newWindow.opener = null
                            }}
                        >Export Cargos</Button>
                        <Button
                            color="secondary"
                            variant='outlined'
                            className='table-search-result-utility-bar-item'
                            onClick={() => {
                                let url = Api.constructGetUrl("/api/Contact/Export", {});

                                const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
                                if (newWindow) newWindow.opener = null
                            }}
                        >Export Contacts</Button>
                        <Button
                            color="secondary"
                            variant='outlined'
                            className='table-search-result-utility-bar-item'
                            onClick={() => {
                                let url = Api.constructGetUrl("/api/MarketInfo/Export", {});

                                const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
                                if (newWindow) newWindow.opener = null
                            }}
                        >Export MarketInfos</Button>
                        <Button
                            color="secondary"
                            variant='outlined'
                            className='table-search-result-utility-bar-item'
                            onClick={() => {
                                let url = Api.constructGetUrl("/api/Agent/Export", {});

                                const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
                                if (newWindow) newWindow.opener = null
                            }}
                        >Export Agents</Button>
                        <Button
                            color="secondary"
                            variant='outlined'
                            className='table-search-result-utility-bar-item'
                            onClick={() => {
                                let url = Api.constructGetUrl("/api/CompanyNamePIC/Export", {});

                                const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
                                if (newWindow) newWindow.opener = null
                            }}
                        >Export CompanyNamePICs</Button>
                        <Button
                            color="secondary"
                            variant='outlined'
                            className='table-search-result-utility-bar-item'
                            onClick={() => {
                                let url = Api.constructGetUrl("/api/Surveyor/Export", {});

                                const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
                                if (newWindow) newWindow.opener = null
                            }}
                        >Export Surveyors</Button>
                    </Grid>
                </Grid>

                <Datatable<BackupFileModel>
                    useDefaultSearchBar={false}
                    pagingType={PagingTypeEnum.None}
                    data={databaseBackupData.databaseBackupFiles}
                    useItemPerPage={false}
                    columns={columns}
                    isDataLoaded={true}
                    className="database-backup-datatable-search-result nice-scroll"
                    useHeaderSort={true}
                    orderColumn={databaseBackupData.orderBy}
                    orderDirection={databaseBackupData.orderDirection}
                    stickyHeader={true}
                    onOrderDirectionChange={(column: DatatableColumnModel<BackupFileModel>, orderDirection: OrderDirection) => {
                        dispatch(setOrderBy(column.Field));
                        dispatch(setOrderDirection(orderDirection));

                        let data = [...databaseBackupData.databaseBackupFiles];
                        if (orderDirection == OrderDirection.Asc) {
                            data = _.sortBy(data, column.Field);
                        } else {
                            data = _.sortBy(data, column.Field).reverse();
                        }

                        dispatch(setDatabaseBackupFiles(data));
                    }}
                ></Datatable>
            </div>
        </>
    )
};

export default DatabaseBackup;